// Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.

import { defer, Observable, finalize } from 'rxjs';

export function withLoading<T>(setLoading: (val: boolean) => void): (source$: Observable<T>) => Observable<T> {
  return (source$: Observable<T>) =>
    defer(() => { // Ensures loading starts ONLY when subscribed, creates a new observable each time
      setLoading(true);
      return source$.pipe(
        finalize(() => setLoading(false))
      );
    });
}

export function relativeChange(oldValue: number, newValue: number): number {
    let decimalChange: number;
    if (oldValue === 0) {
      decimalChange = newValue === 0 ? 0 : 1;
    } else {
      decimalChange = (newValue - oldValue) / Math.abs(oldValue);
    }
    return decimalChange;
}